import React from "react";
var __jsx = React.createElement;
import stl from './InstallmentCalculatorTerms.module.css';
import { useEffect, useState } from "react";
import financingConditionsRequiredDocuments from "@data/financing-conditions-and-required-documents/data.json";
import { useLang } from "@/common/Contexts/LanguageContext";
var InstallmentCalculatorTerms = function InstallmentCalculatorTerms() {
  var lang = useLang();
  var _useState = useState(0),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var _useState2 = useState(financingConditionsRequiredDocuments[lang]),
    data = _useState2[0],
    setData = _useState2[1];
  useEffect(function () {
    setData(financingConditionsRequiredDocuments[lang]);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.termswrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.RDTabs
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.RDTabsHead
  }, data === null || data === void 0 ? void 0 : data.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return setActiveTab(index);
      },
      className: activeTab == index ? stl.activeRDtab : undefined
    }, item.name);
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.RDTabsBody
  }, data === null || data === void 0 ? void 0 : data.map(function (item, index) {
    return activeTab === index && /*#__PURE__*/React.createElement("div", {
      className: stl.RDlistsContainer
    }, item.bulleted_list.map(function (innerItem) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, innerItem.title), /*#__PURE__*/React.createElement("ul", null, innerItem.list_items.split('\n').map(function (item) {
        return /*#__PURE__*/React.createElement("li", {
          dangerouslySetInnerHTML: {
            __html: item
          }
        });
      })));
    }));
  })))));
};

//@ts-ignore
export default InstallmentCalculatorTerms;